import Raven from 'raven-js';

let sentryDSN = false;
// if (false __SENTRYLOG__ === 'production') {
// 	// Set to production DSN
// 	sentryDSN = 'http://0632e37d65214a839bba85a3ebda2013@sentry.konform.com/32';
// } else if (false __SENTRYLOG__ === 'development') {
// 	// Set to development DSN
// 	sentryDSN = 'http://4a47a67c6c1142679b9d4c3859bb5734@sentry.konform.com/17';
// }

sentryDSN && Raven.config(sentryDSN, {
	//whitelistUrls: ['example.com/scripts/'],
	// Will cause a deprecation warning, but the demise of `ignoreErrors` is still under discussion.
	// See: https://github.com/getsentry/raven-js/issues/73
	ignoreErrors: [
		// Random plugins/extensions
		'top.GLOBALS',
		// See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
		'originalCreateNotification',
		'canvas.contentDocument',
		'MyApp_RemoveAllHighlights',
		'http://tt.epicplay.com',
		'Can\'t find variable: ZiteReader',
		'jigsaw is not defined',
		'ComboSearch is not defined',
		'http://loading.retry.widdit.com/',
		'atomicFindClose',
		// Facebook borked
		'fb_xd_fragment',
		// ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
		// See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
		'bmi_SafeAddOnload',
		'EBCallBackMessageReceived',
		// See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
		'conduitPage',
		// Generic error code from errors outside the security sandbox
		// You can delete this if using raven.js > 1.0, which ignores these automatically.
		'Script error.'
	],
	ignoreUrls: [
		// Facebook flakiness
		/graph\.facebook\.com/i,
		// Facebook blocked
		/connect\.facebook\.net\/en_US\/all\.js/i,
		// Woopra flakiness
		/eatdifferent\.com\.woopra-ns\.com/i,
		/static\.woopra\.com\/js\/woopra\.js/i,
		// Chrome extensions
		/extensions\//i,
		/^chrome:\/\//i,
		// Other plugins
		/127\.0\.0\.1:4001\/isrunning/i,  // Cacaoweb
		/webappstoolbarba\.texthelp\.com\//i,
		/metrics\.itunes\.apple\.com\.edgesuite\.net\//i
	],
}).install();

export { Raven as Raven };

export default function logException(ex, context) {
	Raven.isSetup() && Raven.captureException(ex, {
		extra: context,
	});
	/*eslint no-console:0*/
	window.console && console.error && console.error(ex);
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/raven.js
 **/